import { render, staticRenderFns } from "./MatrixReportPageFilters.vue?vue&type=template&id=22ae07b9"
import script from "./MatrixReportPageFilters.vue?vue&type=script&lang=js"
export * from "./MatrixReportPageFilters.vue?vue&type=script&lang=js"
import style0 from "./MatrixReportPageFilters.vue?vue&type=style&index=0&id=22ae07b9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports